// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"1db97370","167":"2d66a947","394":"825eb735","905":"a20fe20a"}[chunkId] + ".css";
};